import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.css',
})
export class ConfirmModalComponent implements OnInit {
  public _title: string;
  public _description: string;
  public _buttonConfirm: string;
  public _buttonClose: string;
  public _innerHtml: string;

  public _showTextarea: boolean = false;
  public _textareaLabel: string = 'Justificativa';
  public _textareaValue: string = '';
  public _textareaRequired: boolean = false;
  public _textareaMinLength: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmModalComponent>
  ) {}

  ngOnInit(): void {
    this._title = this.data.title;
    this._description = this.data.description;
    this._buttonConfirm = this.data.buttonConfirm;
    this._buttonClose = this.data.buttonClose;
    this._innerHtml = this.data.innerHtml;

    this._showTextarea = this.data.showTextarea ?? false;
    if (this._showTextarea) {
      this._textareaLabel = this.data.textareaLabel ?? 'Justificativa';
      this._textareaValue = this.data.textareaValue ?? '';
      this._textareaRequired = this.data.textareaRequired ?? false;
      
      this._textareaMinLength = this.data.textareaMinLength ?? (this._textareaRequired ? 15 : 0);
    }
  }

  /** Retorna se o botão de confirmar deve estar desabilitado */
  public get isConfirmDisabled(): boolean {
    if (this._showTextarea && this._textareaRequired) {
      return this._textareaValue.trim().length < this._textareaMinLength;
    }
    return false;
  }

  close(): void {
    this.dialogRef.close({
      confirm: false,
      textareaValue: null, // Retorna nulo se cancelado
    });
  }

  confirm(): void {
    this.dialogRef.close({
      confirm: true,
      // Retorna o valor do textarea se ele estiver visível, senão nulo
      textareaValue: this._showTextarea ? this._textareaValue : null,
    });
  }
}